export default "__VITE_ASSET__CNvQko9x__"